function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "w6qqgiwjra",
  d: "M0 0h40v35.349H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "q6wvtiy6qb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#w6qqgiwjra"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.067 31.438c-1.605 0-2.675-1.155-2.675-2.696 0-1.57 1.1-2.695 2.675-2.695 1.574 0 2.613 1.125 2.643 2.695 0 1.54-1.04 2.696-2.643 2.696zm2.346-20.29-.653 13.418h-3.386l-.684-13.417h4.723v-.001zm16.97 19.664L22.627 1.872c-1.445-2.496-3.809-2.496-5.254 0L.617 30.811C-.828 33.307.354 35.35 3.243 35.35h33.514c2.889 0 4.071-2.042 2.626-4.537v-.001z",
  fill: "#EBAB63",
  fillRule: "nonzero",
  mask: "url(#q6wvtiy6qb)"
}));

var SvgWarningDarker = function SvgWarningDarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningDarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning_darker.f84513b8.svg";
export { ForwardRef as ReactComponent };